// src/config.js

let frontendUrl;
let backendURL;
let passwordChangeURL;
frontendUrl = "https://its-kompetent.de";

backendURL = "https://api.its-kompetent.de/api";

passwordChangeURL = "https://api.its-kompetent.de";

export { frontendUrl, backendURL, passwordChangeURL };
